module.exports = __webpack_public_path__ + "img/qr-code.a47dc3f.png";